import { computed, signal } from '@preact/signals';
import { isColonyLost } from './colonyLost';
import { ownedPawns } from './entities';

export const isEscMenuOpen = signal(false);
export const isRespawnConfirming = signal(false);

export const allPawnsDowned = computed(
  () => ownedPawns.value.length > 0 && ownedPawns.value.every((p) => p.isDowned === 1)
);

export const canRespawn = computed(() => allPawnsDowned.value || isColonyLost.value);

export const openEscMenu = (): void => {
  isEscMenuOpen.value = true;
};

export const closeEscMenu = (): void => {
  isEscMenuOpen.value = false;
  isRespawnConfirming.value = false;
};

export const toggleEscMenu = (): void => {
  if (isEscMenuOpen.value) {
    closeEscMenu();
  } else {
    openEscMenu();
  }
};

export const startRespawnConfirmation = (): void => {
  isRespawnConfirming.value = true;
};

export const cancelRespawnConfirmation = (): void => {
  isRespawnConfirming.value = false;
};
